<template id="switch-button">
  <div
    class="col col-lg-auto mt-3"
    :class="
      disabled ? 'switch-button-control-disabled' : 'switch-button-control'
    "
  >
    <div class="input-group">
      <label for="switchAcessarField" class="d-flex align-items-center">
        <b class="ms-2 fs-5" @click="changeContent">
          {{ title }}
        </b>
        <div
          class="ms-3 mb-2"
          :class="{
            'switch-button': !disabled,
            'switch-button-disabled': disabled,
            enabled: model.content && !disabled,
            'enabled-disabled': model.content && disabled,
          }"
          @click="changeContent"
          :style="{ '--color': '#FFFFFF' }"
          id="switchAcessarField"
        >
          <div :class="disabled ? 'button-disabled' : 'button'"></div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    disabled: Boolean,
  },
  data() {
    return {
      model: {
        content: false,
      },
    };
  },
  methods: {
    changeContent() {
      if (this.$can("CENTRAL_CADASTROS_GRUPO_ACESSO_VISUALIZAR_EDITAR")) {
        this.model.content = !this.model.content;
      }
    },
  },
  watch: {
    "$parent.acessar": {
      handler() {
        this.model.content = this.$parent.acessar;
      },
    },
    "model.content": {
      deep: true,
      handler() {
        this.$parent.acessar = this.model.content;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/colors.scss";
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
.switch-button-control {
  .switch-button {
    margin-top: 10px !important;
    background: $primary--gray;
    $switch-button-height: 1em;
    $switch-button-color: transparent;
    $switch-button-border-thickness: 2px;
    $switch-transition: all 0.3s ease-in-out;
    $switch-is-rounded: true;

    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    border: $switch-button-border-thickness solid $switch-button-color;
    box-shadow: inset 0px 0px $switch-button-border-thickness 0px
      rgba(0, 0, 0, 0.33);
    border-radius: if($switch-is-rounded, $switch-button-height, 0);

    transition: $switch-transition;

    $button-side-length: calc(
      #{$switch-button-height} - (2 * #{$switch-button-border-thickness})
    );

    cursor: pointer;

    .button {
      height: $button-side-length;
      width: $button-side-length;
      border: $switch-button-border-thickness solid $switch-button-color;
      border-radius: if($switch-is-rounded, $button-side-length, 0);
      background: white;
      box-shadow: 0.5px 0.5px 2px $black-overlay;

      transition: $switch-transition;
    }

    &.enabled {
      background-color: $primary--orange;
      box-shadow: none;

      .button {
        background: white;
        transform: translateX(
          calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
        );
      }
    }
  }
}

.switch-button-control-disabled {
  .switch-button-disabled {
    margin-top: 10px !important;
    background: #ec672366 !important;
    $switch-button-height: 1em;
    $switch-button-color: transparent;
    $switch-button-border-thickness: 2px;
    $switch-transition: all 0.3s ease-in-out;
    $switch-is-rounded: true;

    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    border: $switch-button-border-thickness solid $switch-button-color;
    box-shadow: inset 0px 0px $switch-button-border-thickness 0px
      rgba(0, 0, 0, 0.33);
    border-radius: if($switch-is-rounded, $switch-button-height, 0);

    transition: $switch-transition;

    $button-side-length: calc(
      #{$switch-button-height} - (2 * #{$switch-button-border-thickness})
    );

    cursor: pointer;

    .button-disabled {
      height: $button-side-length;
      width: $button-side-length;
      border: $switch-button-border-thickness solid $switch-button-color;
      border-radius: if($switch-is-rounded, $button-side-length, 0);
      background: white;
      box-shadow: 0.5px 0.5px 2px $black-overlay;

      transition: $switch-transition;
    }

    &.enabled-disabled {
      background-color: #ec672366 !important;
      box-shadow: none;

      .button-disabled {
        background: white;
        transform: translateX(
          calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
        );
      }
    }
  }
}
</style>
